module.exports = __webpack_public_path__ + "static/img/10.68a79f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/miembros/10.jpg
// module id = 4QFN
// module chunks = 0